module.exports = __webpack_public_path__ + "static/media/new_york_times.df3a1c69.svg";